export default __webpack_public_path__ + "static/media/Daco_456015.a72fcf68.png";